module.exports = __webpack_public_path__ + "img/refresh-icon.bc12f7e8.png";